export default function($) {
  var speed = 180; // ms

  $('.js-nav-mobile-button').click(function () {
    $('.js-nav').addClass('js-nav-open');
    $(this).addClass('nav-trigger-active');
  });
  $('.js-nav-close').click(function () {
    $('.js-nav').removeClass('js-nav-open');
    $(this).removeClass('nav-trigger-active');
  });

  $('.menu-item-has-children').click(function () {
    $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
      $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
    });
    $(this).children('.sub-menu').slideToggle(speed);
    $(this).toggleClass('menu-item-has-children--active');
    $(this).siblings('.menu-item').each(function(i, sibling) {
      $(sibling).toggleClass('opacity-60');
    });
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav').length) {
      if ($('.sub-menu').is(":visible")) {
        $('.sub-menu').slideUp(speed);
        $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
      }
    }
  });

  // Styleguide nav
  $('.sg-nav-mobile-button').click(function () {
    $('.js-sg-nav').slideToggle(speed);
  });

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });

  // Scrollable mobile menu

  function scrollableMenu() {
    var ww = $(window).outerWidth();
    if (ww < 1280) {
      var wh = $(window).outerHeight();
      $('.js-nav-items').css('height', wh - 105 );
    } else {
      $('.js-nav-items').css('height', 'auto' );
    }
  }

  scrollableMenu();
  $(window).on('resize', function() {
    scrollableMenu();
  });
}
